module.exports = __webpack_public_path__ + "gs.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/gs.svg
// module id = 582
// module chunks = 0